import { render, staticRenderFns } from "./storeBranches.vue?vue&type=template&id=f5e86ba2&scoped=true"
import script from "./storeBranches.vue?vue&type=script&lang=js"
export * from "./storeBranches.vue?vue&type=script&lang=js"
import style0 from "./storeBranches.vue?vue&type=style&index=0&id=f5e86ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e86ba2",
  null
  
)

export default component.exports